import { config } from '../config';

type GraphQLResponse<T> = { data?: T; errors?: Array<{ message: string }> };

export async function graphql<T>(input: {
  query: string;
  variables?: Record<string, unknown>;
  token?: string;
  organizationId?: string;
}): Promise<T> {
  const response = await fetch(config.graphqlUrl, {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      ...(input.token ? { authorization: `Bearer ${input.token}` } : {}),
      ...(input.organizationId ? { 'x-organization-id': input.organizationId } : {})
    },
    body: JSON.stringify({ query: input.query, variables: input.variables ?? {} })
  });
  const body = await response.json() as GraphQLResponse<T>;
  if (!response.ok || body.errors?.length) throw new Error(body.errors?.[0]?.message ?? `Request failed (${response.status})`);
  if (!body.data) throw new Error('GraphQL response contained no data');
  return body.data;
}

export function activeOrganizationId(): string {
  return localStorage.getItem('payright-organization-id') || config.defaultOrganizationId;
}

export function initializeActiveOrganizationId(organizationIds: string[]): boolean {
  const current = activeOrganizationId();
  if (!organizationIds[0]) {
    if (current) localStorage.removeItem('payright-organization-id');
    return false;
  }
  if (organizationIds.includes(current)) return false;
  localStorage.setItem('payright-organization-id', organizationIds[0]);
  return true;
}
